<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { injectDialogRootContext, Presence } from 'reka-ui'
import { computed, watch } from 'vue'
import { useBodyScrollLock } from '#ui-kit/lib/useBodyScrollLock'
import { OVERLAY_Z_BASE } from '#ui-kit/lib/useOverlayStack'
import { cn } from '#ui-kit/lib/utils'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    zIndex?: number
    closeOnClick?: boolean
  }>(),
  { zIndex: OVERLAY_Z_BASE, closeOnClick: false },
)

const rootContext = injectDialogRootContext()

const dataState = computed(() => (rootContext.open.value ? 'open' : 'closed'))

const isLocked = useBodyScrollLock(rootContext.open.value)
watch(
  () => rootContext.open.value,
  (open) => {
    isLocked.value = open
  },
  { immediate: true },
)

function onClick() {
  if (props.closeOnClick) {
    rootContext.onOpenChange(false)
  }
}
</script>

<template>
  <Presence :present="rootContext.open.value">
    <div
      :data-state="dataState"
      :class="
        cn(
          'fixed inset-0 bg-black/25 backdrop-blur-xs data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0 data-[state=closed]:duration-200 data-[state=open]:duration-300',
          props.class,
        )
      "
      :style="{ zIndex: props.zIndex, pointerEvents: 'auto' }"
      @click="onClick"
      @pointerdown.left.self.prevent
    >
      <slot />
    </div>
  </Presence>
</template>
